var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Checkbox, FormControlLabel, MenuItem } from '@material-ui/core';
import { Field } from 'formik';
import React, { useEffect, useState } from 'react';
import { TopLabeledTextField } from '../../..';
import { MomentTimeZOnes } from '../../../commons/assets/TimeZones';
import { CustomAutoCompleteField } from '../../../commons/CustomAutoCompleteField';
import { CustomTextField } from '../../../commons/CustomTextField';
import { nth } from '../../../commons/utils/NumberUtils';
import { CustomFormikWeekCheckbox } from './CustomFormikWeekCheckbox';
import { RecurrenceWrapper, TextGroupWrapper, TextWrapper, Wrapper, } from './Schedule.Styles';
export var Schedule = function (_a) {
    var values = _a.values, setFieldValue = _a.setFieldValue, errors = _a.errors, touched = _a.touched;
    var recurrenceType = values.recurrence.type;
    var _b = [
        values.doesEnd,
        function (val) { return setFieldValue("doesEnd", val); },
    ], doesEnd = _b[0], setDoesEnd = _b[1];
    var _c = useState('day'), monthPattern = _c[0], setMonthPattern = _c[1];
    useEffect(function () {
        var _a, _b;
        setMonthPattern(((_b = (_a = values.recurrence) === null || _a === void 0 ? void 0 : _a.misc) === null || _b === void 0 ? void 0 : _b.dow) ? 'nth day of the week' : 'day');
    }, [values]);
    var renderRecurrenceComp = function (recurrence) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (recurrence === 'weekly') {
            return (React.createElement(Wrapper, null,
                React.createElement(Field, { component: CustomFormikWeekCheckbox, name: 'recurrence.misc' })));
        }
        else if (recurrence === 'monthly') {
            var days = Array.apply(0, Array(31)).map(function (_, i) { return i + 1; });
            return (React.createElement(React.Fragment, null,
                React.createElement(TopLabeledTextField, { label: 'Monthly Pattern', value: monthPattern, select: true, fullWidth: true, onChange: function (e) {
                        setMonthPattern(e.target.value);
                        if (e.target.value === 'day') {
                            setFieldValue('recurrence.misc.dow', null);
                        }
                        else {
                            setFieldValue('recurrence.misc.dow', 'MO');
                            setFieldValue('recurrence.misc.day', 1);
                        }
                    } },
                    React.createElement(MenuItem, { value: 'day' }, "Days"),
                    React.createElement(MenuItem, { value: 'nth day of the week' }, "Nth Day of the Week")),
                React.createElement(CustomTextField, { label: monthPattern === 'day' ? 'On Day' : 'Order', name: 'recurrence.misc.day', select: true, fullWidth: true, SelectProps: {
                        multiple: monthPattern === 'day',
                        value: monthPattern === 'day'
                            ? ((_c = (_b = (_a = values === null || values === void 0 ? void 0 : values.recurrence) === null || _a === void 0 ? void 0 : _a.misc) === null || _b === void 0 ? void 0 : _b.day) === null || _c === void 0 ? void 0 : _c.length) > 0
                                ? (_d = values === null || values === void 0 ? void 0 : values.recurrence) === null || _d === void 0 ? void 0 : _d.misc.day : [1]
                            : ((_e = values === null || values === void 0 ? void 0 : values.recurrence) === null || _e === void 0 ? void 0 : _e.misc.day) || 1,
                        onChange: function (e) {
                            return setFieldValue('recurrence.misc', __assign(__assign({}, values.recurrence.misc), { day: e.target.value }));
                        }
                    } }, monthPattern === 'day'
                    ? days.map(function (d) { return (React.createElement(MenuItem, { key: d, value: d }, d)); })
                    : [1, 2, 3, 4, 5].map(function (d) { return (React.createElement(MenuItem, { key: d, value: d }, d + nth(d))); })),
                monthPattern !== 'day' && (React.createElement(CustomTextField, { label: 'Week Day', name: 'recurrence.misc.dow', select: true, fullWidth: true, SelectProps: {
                        value: ((_g = (_f = values === null || values === void 0 ? void 0 : values.recurrence) === null || _f === void 0 ? void 0 : _f.misc) === null || _g === void 0 ? void 0 : _g.dow) || 'MO',
                        onChange: function (e) {
                            setFieldValue('recurrence.misc', __assign(__assign({}, values.recurrence.misc), { dow: e.target.value }));
                        }
                    } },
                    React.createElement(MenuItem, { value: 'MO' }, "Monday"),
                    React.createElement(MenuItem, { value: 'TU' }, "Tuesday"),
                    React.createElement(MenuItem, { value: 'WE' }, "Wednesday"),
                    React.createElement(MenuItem, { value: 'TH' }, "Thursday"),
                    React.createElement(MenuItem, { value: 'FR' }, "Friday"),
                    React.createElement(MenuItem, { value: 'SA' }, "Saturday"),
                    React.createElement(MenuItem, { value: 'SU' }, "Sunday")))));
        }
        else {
            return null;
        }
    };
    return (React.createElement(Wrapper, null,
        React.createElement(TextGroupWrapper, null,
            React.createElement(CustomAutoCompleteField, { options: MomentTimeZOnes.map(function (m) { return ({ value: m, label: m }); }), 
                // options={[
                //   {
                //     value: `${global.DialerDefaults.ScheduleTimezone}`,
                //     label: `${global.DialerDefaults.ScheduleTimezone}`,
                //   },
                // ]}
                name: 'timeZone', label: 'Timezone', placeholder: 'Please Select', disabled: true, fullWidth: true }),
            React.createElement(TextWrapper, null,
                React.createElement(CustomTextField, { name: 'startTime', label: 'Start Time', type: 'time', fullWidth: true }),
                React.createElement(CustomTextField, { name: 'endTime', label: 'End Time', type: 'time', fullWidth: true })),
            React.createElement(TextWrapper, null,
                React.createElement(CustomTextField, { label: 'Recurrence Pattern', name: 'recurrence.type', select: true, fullWidth: true, onChange: function (e) {
                        setFieldValue(e.target.name, e.target.value);
                        if (e.target.value === 'monthly') {
                            setFieldValue("recurrence.misc.day", 1);
                            setMonthPattern('day');
                        }
                        else if (e.target.value === 'weekly') {
                            setFieldValue("recurrence.misc", []);
                        }
                        else {
                            setFieldValue("recurrence.misc", '');
                            setDoesEnd(true);
                        }
                    } },
                    React.createElement(MenuItem, { value: 'doesNotRepeat' }, "Does not repeat"),
                    React.createElement(MenuItem, { value: 'daily' }, "Daily"),
                    React.createElement(MenuItem, { value: 'weekly' }, "Weekly"),
                    React.createElement(MenuItem, { value: 'monthly' }, "Monthly")),
                renderRecurrenceComp(recurrenceType),
                recurrenceType !== 'doesNotRepeat' && (React.createElement(RecurrenceWrapper, null,
                    React.createElement(CustomTextField, { name: 'recurrence.value', label: 'Every', type: 'number', fullWidth: true, inputProps: { min: 1 } }),
                    React.createElement("span", null, recurrenceType === 'daily'
                        ? 'Day(s)'
                        : recurrenceType === 'weekly'
                            ? 'Weeks(s)'
                            : recurrenceType === 'monthly'
                                ? 'Month(s)'
                                : null)))),
            React.createElement(CustomTextField, { name: 'startDate', label: 'Start Date', type: 'date', fullWidth: true, onChange: function (e) {
                    if (recurrenceType === 'doesNotRepeat') {
                        setFieldValue('endDate', e.target.value);
                    }
                    setFieldValue(e.target.name, e.target.value);
                } }),
            recurrenceType !== 'doesNotRepeat' && (React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: values.doesEnd, onChange: function (e) {
                        setDoesEnd(e.target.checked);
                    }, name: 'checkedF', disabled: recurrenceType === 'doesNotRepeat' }), label: 'Does End' })),
            doesEnd && recurrenceType !== 'doesNotRepeat' && (React.createElement(CustomTextField, { name: 'endDate', label: 'End Date', type: 'date', fullWidth: true })))));
};
Schedule.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=Schedule.js.map